import { createStateSelectorHook } from 'src/lib/sweetState';
import { ProjectStore } from 'src/store/project';

const useLocalState = createStateSelectorHook(ProjectStore, ['imageAspectRatio']);

export const useViewState = () => {
  const { imageAspectRatio } = useLocalState();

  return {
    imageAspectRatio,
  };
};
